import React, { Component } from 'react';
import getLocale from '../../../i18n/getLocale';


class ScheduleGradeAircraftLineChangedOriginalView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      sgas: {},
      line_style: {
        0: {background: '#D6B953', fontWeight: 'bold'},
        1: {background: '#F5D76E', fontWeight: 'bold'},
      },
    };

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.sgas.aircraft !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        sgas: newProps.sgas,
        loaded: 1,
      });
    }
  }

  

  render() {
    var self = this;
    var style_fb = { background: '#538dd5', color:  '#000'};
    if (self.state.sgas.role == 'COPIL') {
      style_fb = { background: '#fcd5b4', color:  '#000'};
    }
    if (self.state.sgas.role == 'CMS') {
      style_fb = { background: '#4bacc6', color:  '#000'};
    }

    return (
  <tr>

    <td className="text-center" style={self.state.line_style[self.state.sgas.color]}>
      {self.state.sgas.base}
    </td>
    <td className="text-center" style={self.state.line_style[self.state.sgas.color]}>
      {self.state.sgas.aircraft}<br/>
    </td>
    {(self.state.sgas.line !== null) ? <td className="text-center" style={style_fb}>{self.state.sgas.line}</td> : <td className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Indisponivel}</td>}
    {(self.state.sgas.staff !== null) ? <td className="text-center" style={style_fb}>{self.state.sgas.staff}</td> : <td className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Indisponivel}</td>}
    {(self.state.sgas.inscription !== null) ? <td className="text-center" style={style_fb}>{self.state.sgas.inscription}</td> : <td className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Indisponivel}</td>}
    {(self.state.sgas.role !== null) ? <td className="text-center" style={style_fb}>{self.state.sgas.role}</td> : <td className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Indisponivel}</td>}
    {Object.keys(self.props.schedule_days).map(function(k) {
      var day = self.props.schedule_days[k];
      if (typeof self.state.sgas.days_original_view !== 'undefined') {
        if (typeof self.state.sgas.days_original_view[day.day].type !== 'undefined') {
          var style = self.props.initials_colors[self.state.sgas.days_original_view[day.day].type];
          return(
            <td style={style}>{self.state.sgas.days_original_view[day.day].type}</td>
          );
        } else {
          return(
            <td style={{background: 'blue'}}>&nbsp;</td>
          );
        }
        return('');  
      }
    })}

  </tr>
    );
  }
}

export default ScheduleGradeAircraftLineChangedOriginalView;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/ScheduleGradeAircraftLineChangedOriginalView.js